module.exports = __webpack_public_path__ + "static/example1-2d93b39bd6b621900acffd2d13548cc0.png";